import axios from 'axios'
import { Notify } from 'vant'
import i18n from '../i18n'

const CancelToken = axios.CancelToken
window.axiosSources = {}

const DEFAULT_ERROR_MESSAGE = i18n.t('请求失败，请稍后再试')
export const UNAUTHORIZED = 401

const errorMsgs = new Map([
  [400, i18n.t('该请求参数传递错误')],
  [401, i18n.t('该请求认证失败')],
  [403, i18n.t('该请求被禁止访问')],
  [404, i18n.t('请求资源不存在')],
  [500, i18n.t('服务端错误')],
  [504, i18n.t('服务连接超时')]
])

function getErrorMsgByCode (code) {
  return errorMsgs.get(code) ?? DEFAULT_ERROR_MESSAGE
}

const defaultErrorHandler = error => {
  const status = error?.response?.status
  Notify({ type: 'warning', message: getErrorMsgByCode(status) })
}

// const bizErrorHandler = error => {
//   Notify({ type: 'warning', message: error.message })
// }

/**
 * fetch data from backend apis
 * @param {Object} config - Fetch config
 * @param {string} config.url - The reomte api location
 * @param {string} config.method - The request type
 * @param {Object} config.data - Data in request body or querystring
 * @param {Object} config.headers - Additional headers in request
 * @callback config.loading - The loading callback, recieve an argument which indecate if the fetch is loading
 * @callback config.onError - when response http code is not 200 it will be called. it can return a flag to dedicate if continue with default error handler.
 * @callback config.onBusinessError - when remote api returns ErrorCode it will be called. it can return a flag to dedicate if continue with default error handler.
 * @param {string} config.routerCancel - indecate if current fetch can be canceled by router change events, default value is true
 *
 * @returns {Promise}
 */
function fetch ({
  url,
  method = 'POST',
  data,
  loading = () => {},
  headers = {},
  onError,
  onBusinessError,
  routerCancel = true
} = {}) {
  loading(true)
  const config = {
    url,
    method: method, // default method
    baseURL: window.__runtime__ ? window.__runtime__.remoteApiAddress || '' : '',
    headers
  }

  if (method.toUpperCase() === 'POST') {
    config.data = data
  } else if (method.toUpperCase() === 'GET') {
    config.params = data
  }

  if (routerCancel) {
    const source = CancelToken.source()
    window.axiosSources[source.token] = source
    config.cancelToken = source.token
  }

  return axios.request(config)
    .catch(error => {
      if (!axios.isCancel(error)) {
        if (typeof onError === 'function') {
          const next = onError(error)
          if (next) defaultErrorHandler(error)
        } else defaultErrorHandler(error)
      }
    })
    .then((response) => {
      if (response?.data) {
        if (!response.data.ErrorCode) {
          return response.data.Value
        } else {
          if (typeof onBusinessError === 'function') {
            const next = onBusinessError(response.data)
            if (next) {
              Notify({ type: 'warning', message: response.data.ErrorMessage || DEFAULT_ERROR_MESSAGE })
            }
          } else {
            Notify({ type: 'warning', message: response.data.ErrorMessage || DEFAULT_ERROR_MESSAGE })
          }
        }
      }
    })
    .finally(() => {
      if (window.axiosSources[config.cancelToken]) {
        delete window.axiosSources[config.cancelToken]
      }
      loading(false)
    })
}

export default fetch

export function fetchNothing () {
  return Promise.resolve(null)
}
